import { Field, Form, Formik } from "formik";
import React from "react";
import { Button, Col, Container, Row } from "react-bootstrap";
import { injectIntl } from "react-intl";
import { queryCache, useMutation, useQuery } from "react-query";
import Alert from 'react-s-alert';
import * as Yup from "yup";
import ArchiveHeader from "../../../components/ArchiveHeader";
import PageLoading from "../../../components/Loading";
import { ImageUpload, InputFloatingLabel, ReactSelect } from "../../../formik";
import { getSchedule, postSchedule, putSchedule } from '../schedules/xhr';
import { getSpeakers } from "../speakers/xhr";


const AssociationForm = ({ intl, match, history, locale, setLocale}) => {

  const editForm = match.params.id ? true : false;

  const { isLoading, isError, error, data: schedule } = useQuery('schedule', getSchedule, {
    onError: (err) => {
      Alert.error(intl.formatMessage({ id: err.response.data.message }))
    }
  });

  const [postScheduleMutation] = useMutation(postSchedule, {
    onSuccess: (createdSchedule) => {
      if(queryCache.getQueryData('schedule')) {
        queryCache.setQueryData('schedule', schedule => ({
          ...schedule,
          associations: schedule.associations.concat([createdSchedule])
        }));
      }
      Alert.success(intl.formatMessage({id: 'association.create-success'}));
      history.push("/associations");
    },
    onError: (err) => {
      Alert.error(intl.formatMessage({ id: err.response.data.message }))
    }
  })
  
  const addAssociation = async (values) => {
    Alert.warning(intl.formatMessage({id: "alert.s.association.create_do"}));
    await postScheduleMutation({collection: 'association', schedule: values })
  };

  const [putScheduleMutation] = useMutation(putSchedule, {
    onSuccess: (updatedSchedule) => {
      if(queryCache.getQueryData('schedule')) {
        queryCache.setQueryData('schedule', schedule => ({
          ...schedule,
          associations: schedule.associations.map(association => association._id === updatedSchedule._id ? updatedSchedule : association)
        }))
      }
      Alert.success(intl.formatMessage({ id: 'association.update-success' }));
      history.push("/associations");
    },
    onError: (err) => {
      Alert.error(intl.formatMessage({ id: err.response.data.message }))
    }
  })

  const editAssociation = async (values) => {
    Alert.warning(intl.formatMessage({id: "alert.s.association.update_do"}));
    await putScheduleMutation({ collection: 'association',  _id:match.params.id , schedule: values })
  }

  const {
    isLoading: speakersIsLoading,
    isError: speakersIsError,
    error: speakersError,
    data: speakers
  } = useQuery('speakers', getSpeakers, {
    onError: (err) => {
      Alert.error(intl.formatMessage({ id: err.response.data.message }))
    }
  });

  if (isLoading || speakersIsLoading) {
    return <PageLoading />;
  }

  if (isError) {
    return <span>Error: {error.message}</span>
  }

  if (speakersIsError) {
    return <span>Error: {speakersError.message}</span>
  }

  return (
    <React.Fragment>
      <ArchiveHeader locale={locale} setLocale={setLocale} intl={intl} title={editForm ? "button.s.association-update":"button.s.association-create"} back backLink="/associations" />
      <div className="pad-2rem">
        <Container fluid>
          <Row>
            <Col md={4}>
              <Formik
                validationSchema={
                  Yup.object().shape({
                    name: Yup.string().required(),
                    login: Yup.string().required(),
                    password: Yup.string().required(),
                    logo: Yup.string(),
                    speaker_ids: Yup.array()
                  })
                }
                initialValues={editForm
                  ? {
                    ...schedule.associations.find(
                      r => r._id === match.params.id
                    )
                  }
                  : {
                    name: match.params.name ? match.params.name : '',
                    login: '',
                    password: '',
                    logo: '',
                    speaker_ids: [],
                  }}
                enableReinitialize={true}
                onSubmit={({ name, login, password, logo, speaker_ids }) => {
                  editForm ? 
                    editAssociation({ name, login, password, logo, speaker_ids })
                  : addAssociation({ name, login, password, logo, speaker_ids });
                }}
              >
                <Form className="floating-label-form">
                  <Field
                    component={InputFloatingLabel}
                    type="text"
                    name="name"
                    id="name"
                    placeholder={intl.formatMessage({
                      id: "input.name"
                    })}
                    label={intl.formatMessage({
                      id: "input.name"
                    })}
                    required
                  />
                  <Field
                    component={InputFloatingLabel}
                    type="text"
                    name="login"
                    id="login"
                    placeholder={intl.formatMessage({
                      id: "input.login"
                    })}
                    label={intl.formatMessage({
                      id: "input.login"
                    })}
                    required
                  />
                  <Field
                    component={InputFloatingLabel}
                    type="text"
                    name="password"
                    id="password"
                    placeholder={intl.formatMessage({
                      id: "input.password"
                    })}
                    label={intl.formatMessage({
                      id: "input.password"
                    })}
                    required
                  />
                  <Field
                    component={ImageUpload}
                    id="logo"
                    accept="image/*"
                    name="logo"
                    label={intl.formatMessage({
                      id: "button.uploadFile"
                    })}
                    placeholder={intl.formatMessage({
                      id: "button.uploadFile"
                    })}
                  />
                  <Field
                    component={ReactSelect}
                    name="speaker_ids"
                    id="speaker_ids"
                    options={speakers.map((s) => {
                      return {
                        value: s._id,
                        label: `${s.title ? `${s.title} ` : ""}${s.firstName} ${s.lastName}`,
                      };
                    })}
                    isMulti
                  />
                  <Button
                    type="submit"
                    variant="primary"
                  >
                    {editForm ? intl.formatMessage({ id: `button.s.association-update` }) : intl.formatMessage({ id: `button.s.association-create` })}
                  </Button>
                  <br /><br /><br /><br />
                </Form>
              </Formik>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};


export default injectIntl(AssociationForm);
